export const ROOT_BREADCRUMB = {
  name: 'Главная',
  href: '/',
}

export const PROJECT_PORTFOLIO_PANEL_BREADCRUMB = [
  ROOT_BREADCRUMB,
  {
    name: 'Панель проектного портфеля',
    href: '',
  },
]
